import {
    ACTION_UPDATE_MODEL_STEPSBLOCK,
    ACTION_UPDATE_SLIDE_ID_STEPSBLOCK,
    ACTION_REMOVE_MODEL_STEPSBLOCK,
    ACTION_REMOVE_SLIDE_ID_STEPSBLOCK
} from './stepsBlock.action';

const initialState = {model: [{}], activeStep: [1]};

export const stepsBlockReducer = (state = initialState, action = {}) => {
    const {model, activeStep} = state;
    switch (action.type) {
        case ACTION_UPDATE_MODEL_STEPSBLOCK:
            return {
                ...state,
                model: [...model, {...model[model.length - 1], ...action.payload.model}]
            };
        case ACTION_UPDATE_SLIDE_ID_STEPSBLOCK:
            return {
                ...state,
                activeStep: [...activeStep, action.payload.activeStep]
            };
        case ACTION_REMOVE_MODEL_STEPSBLOCK:
            activeStep.pop();
            return {
                ...state,
                activeStep: [...activeStep]
            };
        case ACTION_REMOVE_SLIDE_ID_STEPSBLOCK:
            model.pop();
            return {
                ...state,
                model: [...model]
            };
        default:
            return state;
    }
};

export default stepsBlockReducer;
